import React from "react";
import TableActionButtons from '../../CommonComponents/TableActionButtons';
import EmptyState from '../../CommonComponents/EmptyState';
import { Package } from 'lucide-react';
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';

export default function UserTable({ users, onEdit, onDelete, onToggleStatus }) {
    return (
        <div className={tableContainer}>
            <table className={tableBase}>
                <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                    <tr>
                        <th className={tableHeader + ' text-left'}>No.</th>
                        <th className={tableHeader + ' text-left'}>Username</th>
                        <th className={tableHeader + ' text-left'}>Email</th>
                        <th className={tableHeader + ' text-left'}>Role</th>
                        <th className={tableHeader + ' text-left'}>Branch</th>
                        <th className={tableHeader + ' text-left'}>Status</th>
                        <th className={tableHeader + ' text-center'}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.length === 0 ? (
                        <tr>
                            <td colSpan={7} className={tableCell + ' text-center py-8'}>
                                <EmptyState icon={Package} message="No users found." size="default" />
                            </td>
                        </tr>
                    ) : (
                        users.map((user, idx) => (
                            <tr key={user.id} className={tableRow + ' border-b last:border-0' + (user.status === "DELETED" ? " opacity-50" : "")}>
                                <td className={tableCell + ' text-left'}>{idx + 1}</td>
                                <td className={tableCell + ' text-left'}>{user.username}</td>
                                <td className={tableCell + ' text-left'}>{user.email}</td>
                                <td className={tableCell + ' text-left'}>{user.role}</td>
                                <td className={tableCell + ' text-left'}>{user.branch?.name || user.branch_name || user.branch?.location || user.branch_id || '-'}</td>
                                <td className={tableCell + ' text-left'}>
                                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${user.status === "ACTIVE"
                                        ? "bg-green-100 text-green-600"
                                        : user.status === "INACTIVE"
                                            ? "bg-gray-200 text-gray-400"
                                            : "bg-red-100 text-red-600"
                                        }`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td className={tableCell + ' text-center'}>
                                    <div className="flex items-center justify-center gap-3">
                                        {user.status !== "DELETED" && (
                                            <>
                                                <TableActionButtons
                                                    canEdit
                                                    canDelete
                                                    canToggle
                                                    onEdit={() => onEdit(user)}
                                                    onDelete={() => onDelete(user)}
                                                    onToggle={() => onToggleStatus(user)}
                                                    toggleStatus={user.status}
                                                />
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
